<template>
  <el-dialog title="优惠券" :visible.sync="dialogFormVisible">
  <el-table :data="couponData">
    <el-table-column property="title" label="标题" width="150">
      <template slot-scope="scope">
        <span>{{scope.row}}</span>
      </template>
    </el-table-column>
    <el-table-column property="sub_title" label="副标题" width="200"></el-table-column>
    <el-table-column property="type" label="类型"></el-table-column>
    <el-table-column property="date" label="日期" width="150"></el-table-column>
    <el-table-column property="name" label="姓名" width="200"></el-table-column>
    <el-table-column property="address" label="地址"></el-table-column>
  </el-table>
</el-dialog>

</template>
<script>
import { couponList } from '@/api/coupon'
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  data() {
    return {
       dialogFormVisible: false,
       type:0,
      couponData:[]
    }
  },
  props:{
    keys: {
      type:Number,
      default: 0
    }
  },
  watch: {
    keys(val){
      if(val == 1) {
        this.dialogFormVisible = true
      }
    }
  },
  mounted() {
    this.getCoupon()
  },
  methods:{
    async getCoupon() {
      const res = await couponList({
        "app_id": this.app_id,
        "type": this.type,
        "page": "1"
      })
      if(res.code == 200) {
        console.log('chenggong ',res)
        this.couponData = res.result
      }
    }
  }
}
</script>